import { render, staticRenderFns } from "./customize_tag_drawer_dropdown.vue?vue&type=template&id=245ef448&"
import script from "./customize_tag_drawer_dropdown.vue?vue&type=script&lang=js&"
export * from "./customize_tag_drawer_dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports